"use client";

import {
  SkeletonBox,
  SkeletonContainer,
  SkeletonLabel,
} from "@/components/ui/skeleton";
import { AuthPageHeaderSkeleton } from "../page-header";

function InviteOrgCardSkeleton() {
  return (
    <SkeletonContainer className="items-center gap-3 bg-contrast/4 border border-contrast/8 rounded-lg p-3">
      <SkeletonBox className="size-9 shrink-0 rounded-lg" />
      <div className="flex flex-col gap-1.5 min-w-0 flex-1">
        <SkeletonLabel className="h-3.5 w-32" />
        <SkeletonLabel tone="muted" className="h-3 w-44" />
      </div>
    </SkeletonContainer>
  );
}

function InviteFormSkeleton() {
  return (
    <SkeletonContainer className="flex-col gap-5">
      <div className="flex gap-3">
        <div className="flex-1 flex flex-col gap-1.5">
          <SkeletonLabel className="w-20" />
          <SkeletonBox className="h-9 w-full rounded-md" />
        </div>
        <div className="flex-1 flex flex-col gap-1.5">
          <SkeletonLabel className="w-20" />
          <SkeletonBox className="h-9 w-full rounded-md" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <SkeletonLabel className="w-20" />
        <SkeletonBox className="h-9 w-full rounded-md" />
      </div>
      <SkeletonBox className="h-10 w-full rounded-md" />
    </SkeletonContainer>
  );
}

export function InviteSkeleton() {
  return (
    <>
      <AuthPageHeaderSkeleton />
      <InviteOrgCardSkeleton />
      <InviteFormSkeleton />
    </>
  );
}
